import React from 'react';
import PropTypes from 'prop-types';

import _ from 'lodash';
import numeral from 'numeral';
import moment from 'moment';

import { Button, Header, Icon, Modal, Table, Image, Label } from 'semantic-ui-react';
import { HorizontalBar } from 'react-chartjs-2';

const cf = num => numeral(num).format('0,0');
const pf = num => numeral(num).format('0.0%');
const df = num => numeral(num).format('0.0');

const dyzioPalette = {
  pink: '#fc4085',
  bgPink: '#ffecf3',
  green: '#20c49e',
  bgGreen: '#d4faf1',
  amber: '#fdb02b',
  bgAmber: '#fff1d5',
  blue: '#9ad2ff',
  bgBlue: '#323299',
};

const barOptions = {
  tooltips: {
    mode: 'index',
    intersect: false,
  },
  responsive: true,
  showScale: false,
  scales: {
    xAxes: [{
      stacked: true,
    }],
    yAxes: [{
      stacked: true,
    }],
  },
};

const getDemographics = (data, gender) => {
  const labels = ['13-17', '18-24', '25-34', '35-44', '45-54', '55-64', '65+'];
  const demos = _.map(labels, label => {
    const derivedLabel = `${gender}${label}`;
    return data[derivedLabel];
  });
  return demos;
};

const FacebookInsightsModal = ({ latestStatistic, popupToggleHandler, open }) => {

  if (!latestStatistic) return null;
  const { insights } = latestStatistic;

  if (!open) return null;

  const demographics = insights.totalVideoViewTimeByAgeBucketAndGender;
  const demoPercentages = _.mapValues(demographics, v => (df((v * 100) / insights.totalVideoViewTotalTime)));
  const reactions = insights.totalVideoReactionsByTypeTotal;

  console.log(insights);

  const barData = {
    labels: ['13-17', '18-24', '25-34', '35-44', '45-54', '55-64', '65+'],
    datasets: [
      {
        label: 'male %',
        backgroundColor: dyzioPalette.blue,
        borderColor: dyzioPalette.bgBlue,
        borderWidth: 1,
        data: getDemographics(demoPercentages, 'M'),
      },
      {
        label: 'female %',
        backgroundColor: dyzioPalette.bgPink,
        borderColor: dyzioPalette.pink,
        borderWidth: 1,
        data: getDemographics(demoPercentages, 'F'),
      },
      {
        label: 'unidentified %',
        backgroundColor: dyzioPalette.bgGreen,
        borderColor: dyzioPalette.green,
        borderWidth: 1,
        data: getDemographics(demoPercentages, 'U'),
      },

    ],
  };

  const reactionTypes = [
    'like',
    'love',
    'wow',
    'haha',
    'sad',
    'angry',
  ];

  const fbH4 = {
    padding: 5,
    border: '1px solid #ccc',
    backgroundColor: '#eee',
  };

  const collectedDate = moment(latestStatistic.createdDate).format('MMMM Do YYYY, h:mm:ss a');

  return (
    <Modal
      open={open}
      onClose={popupToggleHandler}
      size="small"
    >
      <Header icon="pie graph" content="Facebook Video Insights" />
      <Modal.Content>
        <h4 style={fbH4}>Impressions and Views</h4>
        <Table basic="very" celled fluid small style={{padding: 5}}>
          <Table.Body>

          <Table.Row key={'totalVideoImpressions'}>
            <Table.Cell>
              <b>Total Video Impressions</b>
            </Table.Cell>
            <Table.Cell>
              { cf(insights.totalVideoImpressions) }
            </Table.Cell>
          </Table.Row>

            <Table.Row key={'totalVideoViews'}>
              <Table.Cell>
                <b>Total Video Views</b>
              </Table.Cell>
              <Table.Cell>
                { cf(insights.totalVideoViews) }
              </Table.Cell>
            </Table.Row>


            <Table.Row key={'totalVideoViewsOrganic'}>
              <Table.Cell>
                <b>Total Video Views Organic</b>
              </Table.Cell>
              <Table.Cell>
                { cf(insights.totalVideoViewsOrganic) }
              </Table.Cell>
            </Table.Row>


            <Table.Row key={'totalVideoViewsPaid'}>
              <Table.Cell>
                <b>Total Video Views Paid</b>
              </Table.Cell>
              <Table.Cell>
                { cf(insights.totalVideoViewsPaid) }
              </Table.Cell>
            </Table.Row>

            <Table.Row key={'totalVideoImpressionsUnique'}>
              <Table.Cell>
                <b>Lifetime Video Total Reach</b>
              </Table.Cell>
              <Table.Cell>
                { cf(insights.totalVideoImpressionsUnique) }
              </Table.Cell>
            </Table.Row>

            <Table.Row key={'ctr'}>
              <Table.Cell>
                <b style={{ color: "blue" }}>Click Through Rate</b>
              </Table.Cell>
              <Table.Cell>
                { pf(insights.totalVideoViews / insights.totalVideoImpressions) }
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>

        <h4 style={fbH4}>Audience Demographics (by total video view time)</h4>
          <HorizontalBar data={barData} options={barOptions} />


        { reactions &&
          <div>
            <br />
            <h4 style={fbH4}>Audience Reactions</h4>
            <Table basic="very" celled fluid small textAlign="center">
              <Table.Body>
                <Table.Row key={'totalVideoImpressions'}>
                  {
                    _.map(reactionTypes, rt => (
                      <Table.HeaderCell>
                        <Image
                          src={`/icons/facebook-${rt}.png`}
                          alt={`${rt}`}
                          size="tiny"
                          centered
                        />
                      </Table.HeaderCell>
                    ))
                  }
                </Table.Row>
                <Table.Row key={'totalVideoImpressionsxx'}>
                  {
                    _.map(reactionTypes, rt => (
                      <Table.Cell>
                        { cf(reactions[rt]) }
                      </Table.Cell>
                    ))
                  }
                </Table.Row>
              </Table.Body>
            </Table>
          </div>
      }
        <br />
        <p className="centered">
          <Label centered icon="clock" color="grey" basic content={`data collected ${collectedDate}`} />
        </p>
      </Modal.Content>
      <Modal.Actions>
        <Button color="green" onClick={popupToggleHandler} inverted>
          <Icon name="checkmark" /> Got it
        </Button>
      </Modal.Actions>
    </Modal>
  );
};


export default FacebookInsightsModal;



/** WEBPACK FOOTER **
 ** ./src/components/facebook-insights-modal/index.js
 **/